(function () {
    'use strict';

    angular.module('asys')
        .controller('ReiterErgebnisController', ReiterErgebnisController);

    ReiterErgebnisController.$inject = [
        '$scope',
        '$log',
        '$q',
        '$location',
        '$analytics',
        '$timeout',
        'lodash',
        'AppConfig',
        'BasisAngebotService',
        'AngebotUtilsService',
        'AngebotKfzService',
        'MiscUtilsService',
        'NavigationService',
        'FilecacheService',
        'FormatUtilsService',
        'LoadingIndicatorService',
        'ErgebnisZeileTarifdetailsService',
        'TarifdetailsService',
        'HtmlUtilsService',
        'SchluesselWerteUtilsService'
    ];
    function ReiterErgebnisController($scope, $log, $q, $location, $analytics, $timeout, _, AppConfig, BasisAngebotService, AngebotUtilsService, AngebotKfzService, MiscUtilsService, NavigationService, FilecacheService, FormatUtilsService, LoadingIndicatorService, ErgebnisZeileTarifdetailsService, TarifdetailsService, HtmlUtilsService, SchluesselWerteUtilsService) {
        var vm = this,
            angebotVm = $scope.angebotVm,
            nextStep,
            angebotsnummerFormatiert = BasisAngebotService.getAngebotsnummer(angebotVm.angebotModel.angebot, true),
            angebotPdfName = FormatUtilsService.replace(AppConfig.ANGEBOT.pdfNames.angebot.name, angebotsnummerFormatiert),
            pendingTarifberechnung = false,
            inkassoarten = BasisAngebotService.getConstant('inkassoarten'),
            toParamsBerechnen,
            gevo = _.get(angebotVm.angebotModel.angebot, 'gevoId'),
            gevos = AppConfig.ANGEBOT.kfz.gevo;

        $log.debug('ReiterErgebnisController', vm);

        vm.onSubmit = onSubmit;
        vm.aktualisiereGuiParameter = aktualisiereGuiParameter;
        vm.getZahlweise = BasisAngebotService.getZahlweise;
        vm.isKaskoselectErlaubt = isKaskoselectErlaubt;
        vm.isRabattschutzErlaubt = isRabattschutzErlaubt;
        vm.isErweiterungVersicherungsschutzErlaubt = isErweiterungVersicherungsschutzErlaubt;
        vm.setZahlweise = setZahlweise;
        vm.changeZahlweiseAltvertrag = changeZahlweiseAltvertrag;
        vm.isTarifartAktiv = isTarifartAktiv;
        vm.updateKaskoart = updateKaskoart;

        vm.onBausteinAktivChanged = onBausteinAktivChanged;
        vm.onKaskoselectChanged = onKaskoselectChanged;
        vm.onRabattschutzChanged = onRabattschutzChanged;
        vm.onKaskoartChanged = onKaskoartChanged;
        vm.updateLeistungsgrenzeHaftpflicht = updateLeistungsgrenzeHaftpflicht;
        vm.aktualisiereTarifart = aktualisiereTarifart;
        vm.setBausteinDeckungssumme = setBausteinDeckungssumme;
        vm.onToggleAngebotFortsetzenIsOpen = onToggleAngebotFortsetzenIsOpen;
        vm.onToggleAngebotProduktinfosIsOpen = onToggleAngebotProduktinfosIsOpen;
        vm.isKopierenErlaubt = isKopierenErlaubt;
        vm.isHinweisBeratungsverzichtErlaubt = isHinweisBeratungsverzichtErlaubt;
        vm.scrollToAltvertrag = scrollToAltvertrag;
        vm.onSelbstbeteiligungChanged = onSelbstbeteiligungChanged;
        vm.getSelbstbeteiligungen = getSelbstbeteiligungen;
        vm.isSelbstbeteiligungDisabled = isSelbstbeteiligungDisabled;
        vm.setSelbstbeteiligung = setSelbstbeteiligung;

        activate();

        function activate() {
            vm.isInitLoading = true;
            vm.beitraegeByProduktGruppe = null;
            vm.vertragspartnerTemplate = null;
            vm.scrollAltvertrag = false;
            vm.isAltvertragOpen = false;
            vm.angebotPdf = null;
            vm.bausteinBlockOpen = {};
            vm.tarifdetailBausteinKeys = {
                bausteinHaftpflichtKasko: ['bausteinHaftpflicht']
            };
            vm.avbNummer = BasisAngebotService.getAvbVersion(angebotVm.angebotModel.angebot, '91');

            if (_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonfahrzeug')) {
                AppConfig.ANGEBOT.zahlweiseText['51'] = 'pro Saison';
            } else {
                AppConfig.ANGEBOT.zahlweiseText['51'] = 'pro Jahr';
            }

            vm.kaskoarten = BasisAngebotService.getConstant('kaskoarten', angebotVm.angebotModel.angebot);
            vm.tarifarten = BasisAngebotService.getConstant('bausteinHaftpflicht.tarifarten', angebotVm.angebotModel.angebot);
            vm.beitraegeAltvertrag = AngebotKfzService.getAltvertragBeitragsUebersicht(angebotVm.angebotModel.angebot);
            vm.gesamtbeitragZuZahlweise = BasisAngebotService.getGesamtbeitragZuZahlweise(angebotVm.angebotModel.angebot, true);

            vm.beitraegeVorhanden = false;
            vm.hasKonditionen = false;
            vm.isAntrag = !BasisAngebotService.isAngebotAenderbar(angebotVm.angebotModel.angebot, 'ANTRAG');
            vm.isTarifdetailsVisible = {};
            vm.isOptionalTarifdetailsVorhanden = {};
            vm.isAngebotFortsetzenOpen = false;
            vm.isAngebotProduktinfosOpen = false;

            if (BasisAngebotService.isGevo(angebotVm.angebotModel.angebot, ['KFZ_TARIFUMSTELLUNG'])) {
                _.map(NavigationService.getAll(), function (step) {
                    if (step.name === 'rechner.gevo2') {
                        step.url = 'rechner.ergebnis';
                        step.title = 'Ihr Beitrag';
                    }
                });
            }

            aktualisiereGuiParameter(vm.isInitLoading && (BasisAngebotService.checkSollBerechnen(angebotVm.angebotModel) || toParamsBerechnen));

            vm.tarifdetailsName = 'bausteinHaftpflichtKasko' + _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.wkz.wert');
            TarifdetailsService.preload([
                vm.tarifdetailsName
            ]);

            ErgebnisZeileTarifdetailsService.preload([
                'bausteinVerkehrsservice'
            ]);

            $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                angebotVm.cssClassMainActive = AppConfig.APP.cssClassMainWidthContainerLarge;
                toParamsBerechnen = _.get(toParams, 'berechnen');

                if (angebotVm.isAngebotAenderbar('ANGEBOT')) {
                    updateKaskoart(_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.kaskoart'), false);
                }
                if (BasisAngebotService.checkSollBerechnen(angebotVm.angebotModel) && toParamsBerechnen !== false) {
                    BasisAngebotService.resetBeitraege(angebotVm.angebotModel.angebot);
                }

                berechnePraemie({
                    angebotSpeichern: true
                }).then(function () {
                });
                if (_.includes($analytics.settings.pageTracking.excludedRoutes, $location.url())) {
                    $analytics.eventTrack('lead', {
                        trackingProvider: 'etracker',
                        path: $location.url(),
                        target: 'Sale',
                        val: '1',
                        sale: 0
                    });
                }
            });

            $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                if (angebotVm.isErsatzgeschaeft() ||
                    (
                        _.includes([
                            gevos.KFZ_NEUGESCHAEFT,
                            gevos.KFZ_ZUSAETZLICHER_VERTRAG,
                            gevos.KFZ_FAHRZEUGWECHSEL
                        ], gevo) &&
                        _.size(angebotVm.angebotModel.angebot.anhaenge) === 0
                    )
                ) {
                    angebotVm.isUploadEnabled = false;
                }
                if ((
                        _.includes([
                            AppConfig.ANGEBOT.zahlweisen.VIERTELJAEHRLICH.wert,
                            AppConfig.ANGEBOT.zahlweisen.MONATLICH.wert
                        ], BasisAngebotService.getZahlweise(angebotVm.angebotModel.angebot).wert) &&
                        !BasisAngebotService.isRechnungBeiZahlweiseErlaubt(angebotVm.angebotModel.angebot)
                    ) || (
                        _.get(angebotVm.angebotModel.angebot, 'zahlungsinformationen.rechnungAuswaehlbar') === false
                    )
                ) {
                    _.set(angebotVm.angebotModel.angebot, 'zahlungsinformationen.inkassoart', inkassoarten.abbucher.wert);
                    angebotVm.CONSTANTS.listen.inkassoart = HtmlUtilsService.createSelectArray(inkassoarten.abbucher);
                    NavigationService.setFollowingDisabled(true);

                } else {
                    angebotVm.CONSTANTS.listen.inkassoart = HtmlUtilsService.createSelectArray(inkassoarten.abbucher, inkassoarten.rechnung);
                }
            });
        }
        function aktualisiereGuiParameter(initLoading) {
            initLoading = _.isNil(initLoading) ? false : initLoading;

            BasisAngebotService.korrigiereZahlweise(angebotVm.angebotModel, true);

            vm.title = AngebotKfzService.getErgebnisSeiteTitle(angebotVm.angebotModel.angebot);
            vm.aktiveTarifart = BasisAngebotService.getBausteinTarifart(angebotVm.angebotModel.angebot, angebotVm.angebotModel.angebot, 'bausteinHaftpflicht');

            vm.beitraegeByProduktGruppe = BasisAngebotService.getBeitraegeGroupedByProduktGruppe(angebotVm.angebotModel.angebot, {
                onlyActive: false,
                convertToArray: false,
                initLoading: initLoading
            });
            vm.beitraegeByProduktGruppeArray = BasisAngebotService.getBeitraegeGroupedByProduktGruppe(angebotVm.angebotModel.angebot, {
                onlyActive: true,
                convertToArray: true,
                initLoading: initLoading
            });

            vm.bausteinHaftpflichtKasko = AngebotKfzService.getBausteinBeitragHaftpflichtKasko(_.cloneDeep(vm.beitraegeByProduktGruppe));

            vm.beitraegeByProduktGruppeArrayKhKasko = {
                KFZ: _.filter(_.cloneDeep(_.get(vm.beitraegeByProduktGruppeArray, 'KFZ')), function (el) {
                    return _.includes(['bausteinHaftpflicht', 'bausteinTeilkasko', 'bausteinVollkasko'], el.bausteinKey);
                })
            };

            vm.beitraegeByProduktGruppeArrayZusatzleistungen = {
                KFZ: _.filter(_.cloneDeep(_.get(vm.beitraegeByProduktGruppeArray, 'KFZ')), function (el) {
                    return _.includes(['bausteinVerkehrsservice', 'bausteinFahrerschutz', 'bausteinInsassenunfallInvaliditaet', 'bausteinInsassenunfallTod', 'bausteinAuslandSchadenschutz', 'bausteinCampingInhaltsschutz'], el.bausteinKey);
                })
            };
            vm.beitraegeByProduktGruppeArrayZusatzleistungen = AngebotKfzService.korrigiereBeitraegeByProduktGruppeArray(vm.beitraegeByProduktGruppeArrayZusatzleistungen);
            vm.moeglicheTarifarten = BasisAngebotService.sortiereTarifarten(_.get(vm.beitraegeByProduktGruppe, 'KFZ.bausteinHaftpflicht.baustein.moeglicheTarifarten', [
                SchluesselWerteUtilsService.create('TARIFART', 'S', 'OPTIMAL')
            ]));

            if (_.size(vm.moeglicheTarifarten) > 1) {
                vm.labelBausteinAuswahlUebersichtKhKasko = _.toUpper(_.get(_.find(vm.tarifarten, ['wert', vm.aktiveTarifart]), 'bezeichnung')) + '-Tarif' + (_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.rabattschutz') ? ' inkl. Rabattschutz' : '');
            } else {
                vm.labelBausteinAuswahlUebersichtKhKasko = 'Ihr Beitrag' + (_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.rabattschutz') ? ' inkl. Rabattschutz' : '');
            }

            vm.produktgruppenAktiv = BasisAngebotService.getProduktGruppen(angebotVm.angebotModel.angebot, true);
            vm.konditionen = angebotVm.angebotModel.angebot.konditionen;

            vm.beitraegeVorhanden = BasisAngebotService.beitraegeVorhanden(angebotVm.angebotModel.angebot);

            vm.aktiveBausteinKeys = ['bausteinHaftpflicht'];
            vm.bausteinHaftpflichtDeckungssummeText = BasisAngebotService.getConstant('bausteinHaftpflicht.deckungssummenText', angebotVm.angebotModel.angebot)[_.get(vm.beitraegeByProduktGruppe, 'KFZ.bausteinHaftpflicht.baustein.leistungsgrenze.code.id')];

            if (_.get(vm.beitraegeByProduktGruppe, 'KFZ.bausteinVollkasko.baustein.aktiv') || _.get(angebotVm.angebotModel.angebot, 'bausteinVollkasko.aktiv')) {
                vm.aktiveBausteinKeys.push('bausteinVollkasko');
            }
            if (_.get(vm.beitraegeByProduktGruppe, 'KFZ.bausteinTeilkasko.baustein.aktiv') || _.get(angebotVm.angebotModel.angebot, 'bausteinTeilkasko.aktiv')) {
                vm.aktiveBausteinKeys.push('bausteinTeilkasko');
            }

            vm.hasKonditionen = MiscUtilsService.isNotEmpty(vm.konditionen);
            vm.vertragspartnerTemplate = AngebotUtilsService.getImprintUrlByMandant(angebotVm.angebotModel.angebot, 'footer');
            vm.tarifdetailsTextProp = 'tarifarten';
            vm.moeglicheZahlweisen = BasisAngebotService.getMoeglicheZahlweisen(angebotVm.angebotModel, true);
            vm.gesamtbeitragZuZahlweise = BasisAngebotService.getGesamtbeitragZuZahlweise(angebotVm.angebotModel.angebot, true);
            vm.ergebnisGesamtLabel = AngebotKfzService.getGesamtbeitragLabel(angebotVm.angebotModel.angebot);

            if (_.get(vm.beitraegeByProduktGruppe, 'KFZ.bausteinVerkehrsservice')) {
                vm.tarifdetailBausteinKeys.bausteinHaftpflichtKasko = ['bausteinHaftpflicht', 'bausteinVerkehrsservice'];
            } else {
                vm.tarifdetailBausteinKeys.bausteinHaftpflichtKasko = ['bausteinHaftpflicht'];
            }
        }
        function onSubmit($event) {
            var goToNextStep = false;

            if (!vm.ergebnisForm.$valid || vm.pending || !vm.beitraegeVorhanden) {
                $event.preventDefault();
                return false;
            }

            LoadingIndicatorService.addInProgress();

            BasisAngebotService.isKontaktErlaubtPartner(angebotVm.angebotModel).then(function (kontaktErlaubt) {
                angebotVm.isKontaktErlaubtPartner = kontaktErlaubt;
            }).catch(function () {
                angebotVm.isKontaktErlaubtPartner = true;
            });

            nextStep = 'rechner.persoenlichedaten';

            BasisAngebotService.speichere(angebotVm.angebotModel).then(function (data) {
                $log.debug('speichere SUCCESS');

                if (data.angebot) {
                    angebotVm.angebotModel.angebot = angular.merge({}, data.angebot);
                }

                return $q(function (resolve, reject) {
                    BasisAngebotService.validiere({
                        tarifkuerzel: angebotVm.angebotModel.tarif.tarifkuerzel,
                        angebot: angebotVm.angebotModel.angebot,
                        formData: angebotVm.angebotModel.formData,
                        stufe: 'ANTRAG_START'
                    }).then(function () {
                        $log.debug('validiere SUCCESS');

                        goToNextStep = true;

                        resolve();
                    }).catch(function () {
                        reject();
                    });
                });
            }).catch(function (error) {
                $log.debug('speichere FAILURE', error);

                if (error === 'ANGEBOT_NICHT_AENDERBAR') {
                    goToNextStep = true;
                }

            }).finally(function () {
                if (goToNextStep) {
                    $scope.$emit('iplusjs:removeAlert', {
                        id: 'ANG_NICHT_AENDERBAR_ANGEBOT'
                    });

                    NavigationService.goToStep(nextStep, {
                        formValidation: true,
                        ignoreFollowingCheck: true
                    });
                }

                LoadingIndicatorService.removeInProgress();
            });
        }
        function berechnePraemie(params) {
            return $q(function (resolve) {
                var config = {
                        params: {
                            angebotSpeichern: false
                        }
                    },
                    analyticsTrackAngebotsnummerToken = false;
                _.merge(config, {
                    params: params
                });

                if (!BasisAngebotService.getAngebotsnummer(angebotVm.angebotModel.angebot)) {
                    analyticsTrackAngebotsnummerToken = true;
                }

                BasisAngebotService.korrigiereZahlweise(angebotVm.angebotModel);
                $scope.$emit('iplusjs:removeAlert', {
                    reason: 'VALIDIERUNG'
                });
                if (pendingTarifberechnung) {
                    return resolve();
                }
                if (!BasisAngebotService.checkSollBerechnen(angebotVm.angebotModel, {
                    bereinigeInaktiveBausteine: false
                }) || toParamsBerechnen === false) {
                    aktualisiereGuiParameter();
                    toParamsBerechnen = null;
                    vm.pending = pendingTarifberechnung = false;
                    vm.isInitLoading = !vm.beitraegeVorhanden;
                    vm.isBeitragLoading = false;

                    $log.debug('USE_CACHED_DATA berechne');
                    return resolve();
                }

                aktualisiereGuiParameter(vm.isInitLoading);

                FilecacheService.removeFile(angebotPdfName, 'report');

                LoadingIndicatorService.addInProgress();
                vm.pending = pendingTarifberechnung = vm.isBeitragLoading = true;

                BasisAngebotService.berechne(angebotVm.angebotModel, config).then(function (data) {
                    var angebotsnummer = BasisAngebotService.getAngebotsnummer(angebotVm.angebotModel.angebot),
                        angebotsToken = BasisAngebotService.getToken(angebotVm.angebotModel.angebot);

                    if (analyticsTrackAngebotsnummerToken && angebotsnummer) {
                        $analytics.eventTrack('lead', {
                            trackingProvider: 'wgv',
                            target: 'tarifauskunftsnummer',
                            value: angebotsnummer,
                            state: 'unchangeable'
                        });

                        $analytics.eventTrack('lead', {
                            trackingProvider: 'wgv',
                            target: 'transaktionsnummer',
                            value: angebotsToken,
                            state: 'unchangeable'
                        });
                    }
                }).catch(function (error) {
                    BasisAngebotService.resetBeitraege(angebotVm.angebotModel.angebot);
                }).finally(function () {
                    aktualisiereGuiParameter();

                    LoadingIndicatorService.removeInProgress();
                    vm.pending = pendingTarifberechnung = false;
                    vm.isInitLoading = !vm.beitraegeVorhanden;
                    vm.isBeitragLoading = false;
                    resolve();
                });
            });
        }
        function isKaskoselectErlaubt() {
            return AngebotKfzService.isKaskoselectErlaubt(angebotVm.angebotModel.angebot);
        }
        function isRabattschutzErlaubt() {
            return AngebotKfzService.isRabattschutzErlaubt(angebotVm.angebotModel.angebot);
        }
        function isErweiterungVersicherungsschutzErlaubt() {
            var produktGruppeKfzBeitraege = _.get(vm.beitraegeByProduktGruppe, 'KFZ', {});
            return (
                produktGruppeKfzBeitraege.bausteinVerkehrsservice ||
                produktGruppeKfzBeitraege.bausteinFahrerschutz ||
                produktGruppeKfzBeitraege.bausteinInsassenunfallInvaliditaet ||
                produktGruppeKfzBeitraege.bausteinAuslandSchadenschutz ||
                produktGruppeKfzBeitraege.bausteinCampingInhaltsschutz
            );
        }
        function setZahlweise(zahlweise) {
            BasisAngebotService.setZahlweise(angebotVm.angebotModel.angebot, zahlweise);
            aktualisiereGuiParameter();
        }
        function isTarifartAktiv(bausteinKey, tarifartWert) {
            return BasisAngebotService.isTarifartAktiv(angebotVm.angebotModel.angebot, bausteinKey, tarifartWert);
        }
        function onBausteinAktivChanged(bausteinKey, aktiv) {
            if (bausteinKey === 'bausteinInsassenunfallInvaliditaet') {
                BasisAngebotService.setBausteinAktiv('bausteinInsassenunfallTod', aktiv, angebotVm.angebotModel.angebot);
            }

            BasisAngebotService.setBausteinAktiv(bausteinKey, aktiv, angebotVm.angebotModel.angebot);

            aktualisiereGuiParameter();
        }

        function onKaskoselectChanged(value) {
            _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.kaskoselect', value);
            updateTarifdaten();
        }

        function onRabattschutzChanged(value) {
            _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.rabattschutz', value);
            updateTarifdaten();
        }

        function onKaskoartChanged(name, value) {
            updateKaskoart(value);
            AngebotKfzService.ermittleSelbstbeteiligungen(angebotVm.angebotModel.angebot, angebotVm.angebotModel.formData);
            updateTarifdaten();
        }
        function updateKaskoart(kaskoart, shouldUpdateTarifdaten) {
            var bausteinHaftpflicht = _.get(angebotVm.angebotModel.angebot, 'bausteinHaftpflicht'),
                bausteinTeilkasko = _.get(angebotVm.angebotModel.angebot, 'bausteinTeilkasko'),
                bausteinVollkasko = _.get(angebotVm.angebotModel.angebot, 'bausteinVollkasko'),
                bausteinCampingInhaltsschutz = _.get(angebotVm.angebotModel.angebot, 'bausteinCampingInhaltsschutz');

            shouldUpdateTarifdaten = _.isNil(shouldUpdateTarifdaten) ? true : shouldUpdateTarifdaten;

            BasisAngebotService.setBausteinAktiv(bausteinHaftpflicht, true);

            if (!kaskoart || kaskoart === 'KEINE') {
                BasisAngebotService.setBausteinAktiv(bausteinTeilkasko, false);
                BasisAngebotService.setBausteinAktiv(bausteinVollkasko, false);
                BasisAngebotService.setBausteinAktiv(bausteinCampingInhaltsschutz, false);
            } else if (kaskoart === 'TEILKASKO') {
                BasisAngebotService.setBausteinAktiv(bausteinTeilkasko, true);
                BasisAngebotService.setBausteinAktiv(bausteinVollkasko, false);
            } else if (kaskoart === 'VOLLKASKO') {
                BasisAngebotService.setBausteinAktiv(bausteinTeilkasko, false);
                BasisAngebotService.setBausteinAktiv(bausteinVollkasko, true);
            }

            if (shouldUpdateTarifdaten) {
                updateTarifdaten();
            }
        }
        function aktualisiereTarifart(tarifart) {
            if (MiscUtilsService.isEmpty(tarifart)) {
                return;
            }

            BasisAngebotService.aktualisiereTarifart(angebotVm.angebotModel.angebot, _.get(tarifart, 'wert'));

            if (_.get(vm.beitraegeByProduktGruppe, 'KFZ.bausteinHaftpflicht.beitrag.' + _.get(tarifart, 'wert'))) {
                aktualisiereGuiParameter();
            } else {
                updateTarifdaten();
            }
        }
        function updateTarifdaten() {
            vm.pending = true;

            return berechnePraemie();
        }
        function updateLeistungsgrenzeHaftpflicht() {
            var haftpflichtLeistungsgrenze = _.get(angebotVm.angebotModel.angebot, 'bausteinHaftpflicht.leistungsgrenze', {});
            if (haftpflichtLeistungsgrenze && !haftpflichtLeistungsgrenze.kfzVSVerlaubt && BasisAngebotService.isBausteinAktiv(angebotVm.angebotModel.angebot, 'bausteinVerkehrsservice')) {
                BasisAngebotService.setBausteinAktiv('bausteinVerkehrsservice', false, angebotVm.angebotModel.angebot);
                _.set(vm.beitraegeByProduktGruppe, 'KFZ.bausteinVerkehrsservice', null);
            }

            updateTarifdaten();
        }
        function setBausteinDeckungssumme(bausteinKey, value) {
            if (value && value.amount) {
                _.set(angebotVm.angebotModel.angebot, bausteinKey + '.deckungssumme', value);
                updateTarifdaten();
            }
        }
        function changeZahlweiseAltvertrag(zahlweise) {
            vm.beitraegeAltvertrag = AngebotKfzService.getAltvertragBeitragsUebersicht(angebotVm.angebotModel.angebot, zahlweise);
        }
        function onToggleAngebotFortsetzenIsOpen(open) {
            vm.isAngebotFortsetzenOpen = open;
        }
        function onToggleAngebotProduktinfosIsOpen(open) {
            vm.isAngebotProduktinfosOpen = open;
        }
        function isKopierenErlaubt() {
            return BasisAngebotService.isKopierenErlaubt(angebotVm.angebotModel);
        }
        function isHinweisBeratungsverzichtErlaubt() {
            return (
                AppConfig.ANGEBOT.beratungsverzichtHinweis &&
                angebotVm.isAngebotAenderbar('ANTRAG')
            );
        }

        function scrollToAltvertrag() {
            vm.scrollAltvertrag = true;

            if (vm.isAltvertragOpen === true) {
                vm.isAltvertragOpen = false;
                $timeout(function () {
                    vm.isAltvertragOpen = true;
                });
            } else {
                vm.isAltvertragOpen = true;
            }

            $timeout(function () {
                vm.scrollAltvertrag = false;
            }, 500);
        }

        function onSelbstbeteiligungChanged(art, selbstbeteiligung) {
            var selbstbeteiligungTeilkasko;

            if (art === 'vollkasko' && selbstbeteiligung) {
                if (isSelbstbeteiligungDisabled('vollkasko_teilkasko', _.get(angebotVm.angebotModel.formData, 'bausteinTeilkaskoSelbstbeteiligung'))) {
                    selbstbeteiligungTeilkasko = _.orderBy(_.filter(_.get(angebotVm.angebotModel.angebot, 'bausteinVollkasko.zasZapAnfrageErgebnis.selbstbeteiligungen'), ['betrag.amount', selbstbeteiligung.amount]), [function (el) { return parseInt(_.get(el, 'betrag2.amount'), 10);}], ['desc'])[0];

                    if (selbstbeteiligungTeilkasko) {
                        _.set(angebotVm.angebotModel.formData, 'bausteinTeilkaskoSelbstbeteiligung', selbstbeteiligungTeilkasko.betrag2);

                        $timeout(function () {
                            $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.ergebnisForm, 'bausteinTeilkaskoSelbstbeteiligung.$$element') ], {
                                force: true
                            });
                        });
                    }
                }
            }

            setSelbstbeteiligung();
        }

        function getSelbstbeteiligungen(art, selbstbeteiligungen) {
            if (art === 'vollkasko' || art === 'teilkasko') {
                return _.map(_.uniqBy(selbstbeteiligungen, 'betrag.amount'), function (selbstbeteiligung) {
                    return _.get(selbstbeteiligung, 'betrag');
                });
            } else if (art === 'vollkasko_teilkasko') {
                return _.map(_.uniqBy(selbstbeteiligungen, 'betrag2.amount'), function (selbstbeteiligung) {
                    return _.get(selbstbeteiligung, 'betrag2');
                });
            }
        }

        function isSelbstbeteiligungDisabled(art, selbstbeteiligung) {
            if (!angebotVm.isAngebotAenderbar('ANGEBOT')) {
                return true;
            }

            if (!selbstbeteiligung) {
                return false;
            }

            var selbstbeteiligung2;
            if (art === 'vollkasko_teilkasko') {
                selbstbeteiligung2 = _.get(angebotVm.angebotModel.formData, 'bausteinVollkaskoSelbstbeteiligung');

                if (!selbstbeteiligung2) {
                    return false;
                }

                return _.size(_.filter(_.filter(_.get(angebotVm.angebotModel.angebot, 'bausteinVollkasko.zasZapAnfrageErgebnis.selbstbeteiligungen'), ['betrag.amount', selbstbeteiligung2.amount]), ['betrag2.amount', selbstbeteiligung.amount])) === 0;
            }
        }

        function setSelbstbeteiligung() {
            AngebotKfzService.setSelbstbeteiligung(angebotVm.angebotModel);
            updateTarifdaten();
        }
    }
})();
